import { Outlet } from "react-router-dom";
// import { useCoreUiLayoutController } from "./controllers/useCoreUiLayoutController";
// import { LoadingOverlay } from "../../../components";
import CoreUiSidebar from "./components/CoreUiSidebar";
import CoreUiHeader from "./components/CoreUiHeader";
import CoreUiFooter from "./components/CoreUiFooter";
import AppAside from "./components/AppAside";
import React, { Suspense } from "react";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const CoreUiAppLayout = () => {
  // Controllers
  // const { state: starterLayoutState } = useCoreUiLayoutController();

  // States
  // const loading = starterLayoutState.loading;
  // const isAuthenticated = starterLayoutState.isAuthenticated;

  // Views
  // if (!loading && !isAuthenticated) {
  //   return <Navigate to="/starter/login" replace />;
  // }

  // if (loading) {
  //   return (
  //     <div className="text-center">
  //       <LoadingOverlay isOpen={true} />
  //     </div>
  //   );
  // }

  // Layout
  return (
    <div>
      <CoreUiSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
        <CoreUiHeader />
        <div className="body flex-grow-1 px-3">
          <Suspense fallback={loading}>
            <Outlet />
          </Suspense>
        </div>
        <CoreUiFooter />
      </div>
      <AppAside />
    </div>
  );
};

export default React.memo(CoreUiAppLayout);
